import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration - these values are public and safe to commit
const firebaseConfig = {
  apiKey: "AIzaSyDVZaHzh3D9agMdA5JvfTLePKf6RSVdDr8",
  authDomain: "concise-slate-484820-c1.firebaseapp.com",
  projectId: "concise-slate-484820-c1",
  storageBucket: "concise-slate-484820-c1.firebasestorage.app",
  messagingSenderId: "872105476308",
  appId: "1:872105476308:web:9a1c9eae386f6820de3b41",
  measurementId: "G-879125ZHBS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
const auth = getAuth(app);

// Named exports
export { auth };

// Default export
export default app;
